import { Box, Button, Divider, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { MaxLocationList } from './MaxLocationList';

export const AdminMaxLocations = () => {
    const navigate = useNavigate();

    const handleCreateLocation = () => {
        navigate('/admin/max-locations/create');
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100%',
                height: '100%',
            }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 3, pb: 2 }}>
                <Typography variant="h5">Max Security Locations</Typography>
                <Button variant="contained" onClick={handleCreateLocation}>
                    Create Location
                </Button>
            </Box>
            <Divider />
            <MaxLocationList />
        </Box>
    );
};
